export const SET_FORECAST_DEPRECIATION_DATA = "SET_FORECAST_DEPRECIATION_DATA"
export const SET_FORECAST_DEPRECIATION = "SET_FORECAST_DEPRECIATION"